import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import Swal from 'sweetalert2';
import { Config } from "../../../config/constants";
import { SafeResourceUrl,DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-payment-link',
  templateUrl: './payment-link.component.html',
  styleUrls: ['./payment-link.component.scss'],
  providers: [DatePipe],
})
export class PaymentLinkComponent implements OnInit {

  tokenId:any;
  policyInfoData:any=[];
  policyAmount:any=0;
  policyDBID:any=0;
  showMaskedCard = false;
  constructor(private sanitizer: DomSanitizer,public route: ActivatedRoute,private base: BaseService,private config:Config,private datePipe: DatePipe, public user: UserService,private recaptchaV3Service: ReCaptchaV3Service) {
    this.route.queryParams.subscribe(params => {
      this.tokenId = params['sessionid'];
      // sessionStorage.setItem('loginURLAttempted', 'true');
    });
   }
  ngOnInit(): void {
    if(this.tokenId!=null){
      this.verifyTokenAndGetDetails()
    }
  }
  checkForCaptcha:boolean=false;
  errorCaptchmsg:boolean=false;
  showPaymentAlreadyDone:boolean=false;
  showLinkExpiredMessage:boolean=false;
  showPaymentNotDone:boolean=false;
  brokerName:any;
  brokerEmail:any;
  brokerPhoneNumber:any;
  resolved(captchaResponse: string) {
    if(captchaResponse==null){
      this.checkForCaptcha=false;
      this.errorCaptchmsg=true;
    }else{
      this.checkForCaptcha=true;
      this.errorCaptchmsg=false;
    }
  }
  purchaserEmailAddress:any;
  policyNumber:any;
  verifyTokenAndGetDetails(){
    this.base.callPostService(this.config.verifyTokenAndGetDetails+this.tokenId, null).subscribe((data: any) => {
      this.policyInfoData=[];

      if(data.status==true){
        this.showPaymentNotDone=true;
        this.showPaymentAlreadyDone=false;
        this.showLinkExpiredMessage=false;
        this.policyAmount=data.data.amount;
        this.brokerName=data.data?.brokerName;
        this.policyDBID=data.data.id;
        this.policyInfoData.push(data.data);
        // sessionStorage.setItem('loginURLAttempted', 'true');
        // localStorage.setItem('currentToken', JSON.stringify(data?.accessToken));
      }else{
        if(data.message=='Payment is already done.'){
          this.showPaymentNotDone=false;
          this.showLinkExpiredMessage=false;
          this.showPaymentAlreadyDone=true;
          this.purchaserEmailAddress=data.data?.purchaserEmailAddress
          this.policyId=data.data?.id;
          this.policyNumber=data.data?.policyNumber;
          this.brokerName=data.data?.brokerName;
          // sessionStorage.setItem('loginURLAttempted', 'true');
          // localStorage.setItem('currentToken', JSON.stringify(data?.accessToken));
        }else if(data.message=="Link is Expired. Please contact your agent"){
          this.showPaymentNotDone=false;
          this.showLinkExpiredMessage=true;
          this.showPaymentAlreadyDone=false;
          this.brokerName=data.data?.brokerName;
          this.brokerEmail=data.data?.email;
          this.brokerPhoneNumber=data?.data.phoneNumber;
          // sessionStorage.setItem('loginURLAttempted', 'true');
          // localStorage.setItem('currentToken', JSON.stringify(data?.accessToken));
        }else{
          this.showPaymentNotDone=false;
          Swal.fire('',data.message,'error');
        }
      }
      }, error => {
    }, () => { });
  }
  viewPolicyDetailsPopup:boolean=false;
  viewPolicyDetailsPopup1:boolean=false;
  agentcbtn:boolean=true;
  hidecircle:boolean=true;
  UrlBoxPolicy: any;
  UrlBoxPolicyDownload: any;
  tabs = [
    { active: 'active', tabcontent: 'tabcontent' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    
    ];
  openTabs(index){
    this.reset();
    if(index==3){
      this.onSelectedBoxFile(index)
    }
    this.tabs[index].active = 'active';
    this.tabs[index].tabcontent = 'tabcontent';
    
    if(index==0){
      this.hidecircle=true;
    }else{
      this.hidecircle=false;
    }
  if(index==2 || index==3){
    this.agentcbtn=false;
  }else{
    this.agentcbtn=true;
   } 
  }
  reset() {
    for (let i = 0; this.tabs.length > i; i++) {
    this.tabs[i].active = '';
    this.tabs[i].tabcontent = 'hide';
    }
  }
  PopupPlanName:any;
  PopuptotalAmount:any;
  UrlBoxPolicy1:SafeResourceUrl;
  planNameClick(planName,totalAmount){
    this.PopupPlanName=planName;
    this.PopuptotalAmount=totalAmount;
  }
  onSelectedBoxFile(index){
    this.base.callGetServiceCall(this.config.PreviewLinkSales).subscribe((data:any) =>{
      this.UrlBoxPolicy=data.data.previewLink;
      this.UrlBoxPolicy1=this.sanitizer.bypassSecurityTrustResourceUrl(this.UrlBoxPolicy);
      this.UrlBoxPolicyDownload=data.data.downloadLink;
    },error=>{{
    }},()=>{});
    if(index!==3){
      setTimeout(() => 
      {
        this.viewPolicyDetailsPopup1 = !this.viewPolicyDetailsPopup1;
      },
      2000);
    }
  }
  downloadPolicyWording(){
    var win = window.open(this.UrlBoxPolicyDownload, '_blank');
  }
  cardType: any;
  cardNoValid: boolean=false;
  cardNoToSend: any;
  cardError: boolean=false;
  expirydateValid: boolean=false;
  expDate1ToSend: any;
  expiryyrValid: boolean=false;
  expDateYearToSend: any;
  expDate1ToSend2:any;
  cardNoClick(){
    this.cardNoValid=false;
  }
  ValidateCreditCardNumber(){
    var ccNum = this.cardNoToSend;
  
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/; 
    var isValid = false;
  
    if (visaRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="VISA"
    } else if(mastercardRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="MasterCard"
    } else if(amexpRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="Amex"
    } else if(discovRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="Discover"
    }else{
      isValid=false;
    }
    if(isValid==true){
    this.cardError=false;
    }else{
    this.cardError=true;
    }
  }
  expiryDateClick(){
    this.expirydateValid=false;
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
      // localStorage.removeItem('responseID');
      // this.blockUI.stop()
      this.expirydateValid=true;
      // Swal.fire('',"Expiry Date Invalid.",'error')
    }
    else{
      this.expiryyrValid=false;
      this.expirydateValid=false;
    }
    }
    expiryYearClick(){
    this.expiryyrValid=false;
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
      this.expiryyrValid=true;
    }
    else{
      this.expiryyrValid=false;
      this.expirydateValid=false;
    }
    }
    onClickPay(){
      //debugger
      this.expDate1ToSend2=this.expDate1ToSend+this.expDateYearToSend
      const request = {
        "creditCardInfo": {
          "ccNum": this.cardNoToSend,
          "expDate": this.expDate1ToSend2
        },
        "id": this.policyDBID,
        "token": this.tokenId
      }
      this.base.callPostService(this.config.paymentLinkPay, request).subscribe((data: any) => {
        ////
        if(data.status==true){
          this.showPaymentNotDone=false;
          this.showLinkExpiredMessage=false;
          this.showPaymentAlreadyDone=true;
          this.purchaserEmailAddress=data.data?.purchaserEmailAddress
          this.policyId=data.data?.id;
          this.policyNumber=data.data?.policyNumber;
        }else{
          Swal.fire('',data.message,'error');
        }
      }, error => {
      }, () => { });
    }
    captchaCheck(){
      if(this.checkForCaptcha==false){
        this.errorCaptchmsg=true;
      }
    }
  email:any[]=[];
  email1="";
  email2="";
  emailErrorFlag: boolean=false;
  printPopup: boolean=false;
  policyId:any;
  onSendEmail(){
    this.email=[];
    if(this.emailNotValid1=="" && this.emailNotValid==""){
    if(!this.email1){this.emailErrorFlag=true}else{this.emailErrorFlag=false}
    if(this.emailErrorFlag==false){
      this.printPopup=false;
      this.email.push(this.email1)
      if(this.email2!=null && this.email2!=""){
        this.email.push(this.email2)
      }
      const request={
        "email": this.email,
        "policyId": this.policyId
      }
      this.base.callPostService(this.config.getPolicyEmailSend,request).pipe()
      .subscribe(
          data => {
            this.emailErrorFlag=false;
            this.printPopup=false;
            Swal.fire('','Email sent successfully.','success');    
            this.email1="";
            this.email2="";
          },error=>{},()=>{});
    }
  }
  }
  clear(){
    this.emailNotValid1="";
    this.emailNotValid="";
  }
onRemoveEmailError(){
  this.emailErrorFlag=false;
  }      emailNotValid: string="";
  emailCheck(){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  
  if (!re.test(this.email1.toLowerCase())){
    this.emailNotValid="Please enter valid Email";
  }else{
    this.emailNotValid="";
  }
  }
  emailNotValid1: string="";
  emailCheck1(){
    if(this.email2!=""){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  
      if (!re.test(this.email2.toLowerCase())){
        this.emailNotValid1="Please enter valid Email";
      }else{
        this.emailNotValid1="";
      }
    }
    else{
      this.emailNotValid1="";
    }
  }
  getPolicyDocs(){
    this.base.callGetServiceCall(this.config.getPolicyDocsByPolicyId+this.policyId).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,this.policyNumber)
      }
    },error=>{{
    }},()=>{});
  }
  checkPaymentAmount(){
    this.recaptchaV3Service.execute('submit_form').subscribe((token: string) => {
      const formData = {
       
        recaptchaToken: token,
      };
      //  console.log('Form data to submit:', formData);
this.user.getV3RecaptchaVerification(formData.recaptchaToken).subscribe((data:any) =>{
     debugger
    if(data.success==true) {
    this.base.callPostService(this.config.checkPaymentAmount+this.policyAmount+'&tokenId='+this.tokenId, null).subscribe((data: any) => {
        if(data.status==false){
          if(data.message=='This link is no longer valid. Please contact your broker.'){
            Swal.fire('',data.message,'error');
            this.showPaymentNotDone=false;
            this.showLinkExpiredMessage=false;
            this.showPaymentAlreadyDone=false;
          }else{
            Swal.fire({
              html: 'There is a change in your premium amount.<strong> The new amount is '+ data.data+'.</strong> If you have any questions, please contact your broker.',
              icon: 'warning',
              showCancelButton: false,
              cancelButtonColor: '#d33',
              confirmButtonText: 'Accept'
            }).then((result) => {
              if (result.isConfirmed) {
                this.verifyTokenAndGetDetails();
              }
            })
          }
        }else{
          this.onClickPay();
        }
      }, error => {
    }, () => { });
  }
     
     else{
    // this.error="reCaptcha Verification Failed";
     }
    },error=>{{
    }},()=>{});
      
    });
  }
}
